import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ReactPlayer from 'react-player/youtube';
import background from '../images/blurry.jpg';


const About = () => {

  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
          קצת עליי
        </h1>


        <p className='text-lg font-normal max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>

          טניה היא קוסמטיקאית מוסמכת, בוגרת ביה"ס
          של חוה זינגבוים עברה השתלמות בביה"ח
          איכילוב ומתמחה בתחומי טיפול נוספים.        </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          בקליניקה הביתית של טניה הממוקמת ברחובות
          תוכלו ליהנות מטיפולי קוסמטיקה ואסתטיקה
          מתקדמים המותאמים לכל סוגי העור וטיפולים
          נוספים כמו: עיצוב גבות בשעווה ופינצטה,
          שעוות גוף ועוד.
        </p>




        <p className='text-lg font-bold max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>

          צרו קשר בקליק               </p>
      </div>


      <div style={divStyle} className="my-8 py-8 bg-gradient-to-l from-mainRing to-secondaryRing p-4 rounded-3xl flex flex-col items-center justify-center">
        <div data-aos="fade-zoom-in" data-aos-easing="linear" className='mt-8 text-3xl font-bold text-center text-white'>סרטון מהקליניקה</div>
        <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[260px] mx-auto mt-4 bg-white"></div>
        <iframe
          src="https://player.vimeo.com/video/876842529?h=6e650e7c1f"
          width=""
          height="550"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          style={{ borderRadius: '32px' }}
          className='my-8 border-2'
        ></iframe>
      </div>



      <div data-aos="fade-zoom-in" data-aos-easing="linear" className='mt-16 text-3xl font-bold text-center text-main'>טיפולים בקליניקה</div>
      <div data-aos="fade-zoom-in" data-aos-easing="linear" className="h-[1px] w-[260px] mx-auto mt-4 bg-main"></div>


    </div>

  )

}


export default About